import { createAction, props } from '@ngrx/store';

export const selectCartItem = createAction('[Cart] Select Cart Item', props<{ cartItemId: string | undefined }>());
